export const capitalizeFirstCharacter = (string = '') => {
	return string?.[0]?.toUpperCase() + string?.slice(1);
};
